import { Component, OnInit, Input } from "@angular/core";
import { ModalService } from "src/app/modules/modal/services/modal.service";

@Component({
  selector: "app-outbidded-message",
  templateUrl: "./outbidded-message.component.html",
  styleUrls: ["./outbidded-message.component.scss"],
})
export class OutbiddedMessageComponent implements OnInit {
  @Input() data: any = null;

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.closePopup();
  }

  ngOnInit(): void {
    this.data = [].concat(...[...Object.values(this.data)]);
  }
}
